__turbopack_context__.v({
  "styledBlockContent": "Artikkel-module__BCyTVa__styledBlockContent",
});
